var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Text, CurrencyInput } from "@brushfire/ui";
import { useIntl } from "react-intl";
import { convertCurrencyStrToDecimal } from "../../../../../data/helpers";
var CustomPriceInput = function (_a) {
    var amount = _a.amount, id = _a.id, name = _a.name, currencyLocale = _a.currencyLocale, formikContext = _a.formikContext, disabled = _a.disabled, removeCustomPriceError = _a.removeCustomPriceError, addCustomPriceError = _a.addCustomPriceError, attendeeId = _a.attendeeId, fixedQuantityDonation = _a.fixedQuantityDonation, isBLADonation = _a.isBLADonation;
    var intl = useIntl();
    var _b = __read(useState(false), 2), hasError = _b[0], setHasError = _b[1];
    var inputIsLessThanMinimum = function (inputStr) {
        var inputAmount = convertCurrencyStrToDecimal(inputStr, intl, currencyLocale);
        return amount && inputAmount < amount;
    };
    var handleChange = function (e) {
        var _a, _b;
        var inputAmount = convertCurrencyStrToDecimal(e.target.value, intl, currencyLocale);
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue(name, inputAmount);
        if ((fixedQuantityDonation && inputAmount > 0) || isBLADonation) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("".concat(name.split(".").shift(), ".quantity"), 1);
        }
        else if (fixedQuantityDonation && inputAmount <= 0) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("".concat(name.split(".").shift(), ".quantity"), 0);
        }
        var quantity = (_b = (_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.attendees.find(function (a) { return a.typeId === attendeeId; })) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 0;
        if (amount && inputAmount < amount && quantity > 0) {
            addCustomPriceError(attendeeId);
        }
        else {
            removeCustomPriceError(attendeeId);
            setHasError(false);
        }
    };
    var placeholderText = intl.formatNumber(amount !== null ? amount : 0, {
        style: "currency",
        currency: currencyLocale !== null && currencyLocale !== void 0 ? currencyLocale : "USD",
    }) + " or more";
    return (_jsx("div", __assign({ className: "custom-price-input" }, { children: _jsx(CurrencyInput, { label: "Custom Price", id: id, name: name, isFieldRequired: true, currency: currencyLocale, onChange: function (e) { return handleChange(e); }, onBlur: function (e) {
                if (inputIsLessThanMinimum(e.target.value)) {
                    setHasError(true);
                }
                else {
                    setHasError(false);
                }
            }, hiddenLabel: true, disabled: disabled, className: "field", hasError: hasError, description: amount !== null &&
                amount !== 0 && _jsx(Text.Mini, __assign({ className: "d-block text-center" }, { children: "Fees vary by amount" })), placeholder: placeholderText }) })));
};
export default CustomPriceInput;
